import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useState } from "react";
import { useLocalState } from "../../../utils/hooks/global/useLocalStorage";
import CustomButton from "../../global/CustomButton";

// A row action on a user that asks for confirmation, then PATCHes
// /users/:id/<path> with the body. onChange receives the updated user.
const UserActionButton = ({
  user,
  path,
  body,
  label,
  icon,
  title,
  text,
  destructive = false,
  onChange,
}) => {
  const [jwt] = useLocalState(null, "jwt");
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleConfirm = async () => {
    setSaving(true);
    setError(null);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/users/${user.id}/${path}`,
        {
          method: "PATCH",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
          body: JSON.stringify(body),
        }
      );
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.message || `Request failed (${response.status})`);
      }
      setOpen(false);
      onChange?.(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <CustomButton
        buttonText={label}
        icon={icon}
        onClick={() => {
          setError(null);
          setOpen(true);
        }}
      />
      <Dialog
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow:
              "rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px",
            width: "420px",
            maxWidth: "90%",
          },
        }}
        open={open}
        onClose={() => !saving && setOpen(false)}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{text}</DialogContentText>
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <CustomButton
            onClick={() => setOpen(false)}
            buttonText="Cancel"
            disabled={saving}
          />
          <CustomButton
            onClick={handleConfirm}
            buttonText={saving ? "Saving…" : label}
            color={destructive ? "lRed" : "black"}
            disabled={saving}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UserActionButton;
